import React, { Component } from 'react'
import { Archive, Heart, ChevronDown } from 'react-feather'
import HumanTime from 'human-time'

import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import ButtonTooltip from './ButtonTooltip'
import Snippets from './Snippets'

import '../App.css'

class SnippetsButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSnippetsEmpty: Snippets.isEmpty(),
            copied: false,
        }
        this.onClick = this.onClick.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.snippetSubscriptionToken = undefined
    }

    componentDidMount() {
        const self = this
        self.snippetSubscriptionToken = Snippets.subscribe((token) => {
            self.setState(Object.assign({}, self.state, {
                isSnippetsEmpty: Snippets.isEmpty(),
            }))
        })
    }
    componentWillUnmount() {
        if (this.snippetSubscriptionToken) {
            Snippets.unsubscribe(this.snippetSubscriptionToken)
        }
    }

    onClick(event) {
        const self = this
        try {
            Snippets.store(self.props.text)

            self.setState(Object.assign({}, self.state, {
                copied: true,
            }))

            if (self.props.onTextRetrieved) {
                self.props.onTextRetrieved()
            }
        }
        catch(e) { /* ignore */ }

        setTimeout(() => {
            self.setState(Object.assign({}, self.state, {
                copied: false,
            }))
        }, 700)
    }

    onSelect(event, key) {
        if (this.props.onTextRetrieved) {
            const obj = Snippets.retrieve(key)
            if (obj) {
                event.preventDefault()
                this.props.onTextRetrieved(event, obj.text)
            }
        }
    }

    render() {
        const self = this

        const disabled = !this.props.text || this.props.text.length === 0

        const icon = this.state.copied
            ? <Heart className="icon-xs" />
            : <Archive className="icon-xs" />

        const snippets = this.state.isSnippetsEmpty ? [] : Snippets.getList()
        const now = new Date().getTime()
        const dropdownDisabled = !this.props.onTextRetrieved || this.state.isSnippetsEmpty

        return (
            <ButtonTooltip tooltipMessage={ this.props.tooltipMessage || "Snippets..." }
                placement={ this.props.tooltipPlacement || "top" }>
                <div className="flex">
                    <Button
                        variant={ this.props.noOutline ? "ghost" : "outline" }
                        size="icon-sm"
                        className="card-head-button rounded-r-none border-r-0"
                        onClick={ this.onClick }
                        disabled={ disabled }>
                        { icon }
                    </Button>
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button
                                variant={ this.props.noOutline ? "ghost" : "outline" }
                                size="icon-sm"
                                className="card-head-button rounded-l-none px-1"
                                disabled={ dropdownDisabled }>
                                <ChevronDown className="h-3 w-3" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="max-w-xs">
                            { snippets.map(entry => {
                                const txt = entry.text.replace(/[\r\n]/gi, ' ').replace(/^ +/, '').replace(/ +$/, '')
                                return (
                                    <DropdownMenuItem
                                        key={ entry.key }
                                        onClick={ (event) => { self.onSelect(event, entry.key) } }
                                        className="flex-col items-start copy-from-snippets">
                                        <p className="snippets-at text-xs text-muted-foreground mb-0.5">
                                            { HumanTime((now - entry.at)/1000) }
                                        </p>
                                        <span className="nowrap copy-from-snippets text-sm truncate w-full">
                                            { txt }
                                        </span>
                                    </DropdownMenuItem>
                                )
                            })}
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </ButtonTooltip>
        )
    }
}

export default SnippetsButton
